import type { ReactNode } from 'react';

export interface EmptyStateProps {
  /** Decorative — hidden from assistive technology; the title carries the meaning. */
  icon: ReactNode;
  title: string;
  subtitle: string;
  action?: { label: string; onClick: () => void };
}

export function EmptyState({ icon, title, subtitle, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="mb-4 text-text-faint" aria-hidden="true">
        {icon}
      </div>
      <h3 className="text-lg font-medium text-text mb-1">{title}</h3>
      <p className="text-sm text-text-muted max-w-sm mb-6">{subtitle}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="inline-flex min-h-11 items-center gap-2 rounded-sm bg-primary px-4 py-2 text-sm font-medium text-text-inverse transition-colors hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
